import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'
import { listPresentations } from '@/api/presentations/presentations'

export function requirePresentationAgent(enabled: boolean, params: { orgSlug: string; projectId: string }) {
  if (!enabled) {
    throw redirect({
      to: '/$orgSlug/$projectId/content/text',
      params: { orgSlug: params.orgSlug, projectId: params.projectId }
    })
  }
}

export const Route = createFileRoute('/_auth/$orgSlug/$projectId/presentation-agent')({
  beforeLoad: ({ context, params }) => {
    const enabled = context.user.userOrgProfile?.enabled_features.presentation_agent ?? false
    requirePresentationAgent(enabled, params)
  },
  loader: async ({ params }) => ({ presentations: await listPresentations(Number(params.projectId)) }),
  component: PresentationAgentLayout
})

function PresentationAgentLayout() {
  return (
    <div className="flex h-svh shrink-0 flex-col overflow-hidden">
      <Outlet />
    </div>
  )
}
